import type { Dayjs } from "dayjs"
import { createContext } from "react"

export const DateContext = createContext<Dayjs | null>(null)
